import React from 'react'
import '../index.scss'

const Practice: React.FC = () => {
  return <div className="animate ~h-5 ~w-percent-85 ~rounded-3xs ~mb-2" />
}

export default Practice
